// extracted by mini-css-extract-plugin
export var label = "_hz-0";
export var treatmentCard = "_hz-1";